import React from "react";
import PropTypes from "prop-types";
import {useDispatch} from "react-redux";
import UrProvider from "@mnjsplatform/data/lib/api/UrProvider";
import Array from "lodash";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";

const CheckBoxJson = (props) => {
    const dispatch = useDispatch();
    const urProcessed = props.dataItem.rawData.ColumnUpdateRules[props.fieldInfo.Name];
    const urProvider = new UrProvider(urProcessed);
    const params = urProvider.getParamsForExecRules(props.dataItem, props.rowIndex);
    const dataRawJson = params["DataSourceJson"];
    if (!dataRawJson)
        return null;
    const meta = JSON.parse(dataRawJson);
    const isSingleControl = meta.length === 1;
    const isMultiValues = (params.IsMultiValues && params.IsMultiValues === 1) ?? false;
    const values = JSON.parse(props.value) ?? null;
    const onChange = async (controlId, e) => {
        try {
            let newCheckedValues;
            let dbValue;
            if (isSingleControl) {
                dbValue = newCheckedValues = e.target.checked ? 1 : 0;
            } else {
                if (isMultiValues) {
                    newCheckedValues = (values ?? []).filter(id => true);
                    if (e.target.checked) {
                        if (!newCheckedValues.find(cv => cv.Id === controlId)) {
                            newCheckedValues.push({Id: controlId});
                        }
                    } else {
                        newCheckedValues = values.filter(cv => cv.Id !== controlId);
                    }
                    dbValue = newCheckedValues.length === 0 ? null : JSON.stringify(newCheckedValues);
                } else {
                    dbValue = newCheckedValues = e.target.checked ? controlId.toString() : null;
                }
            }
            await dispatch(props.dataItem.setField(props.rowIndex, props.fieldInfo.Name, dbValue));
            if (props.onChanged)
                props.onChanged(newCheckedValues);
        } catch (error) {
            dispatch(errorRaised(error));
        }
    }
    //console.log(`${props.fieldInfo.Name}: checkedValues=${JSON.stringify(values)} value: ${props.value} isMultiValues: ${isMultiValues}`);
    const getChecked = (currentControlId) => {
        let isChecked;
        if (isSingleControl) {
            isChecked = values === 1;
        } else {
            if (isMultiValues) {
                isChecked = (values && Array.isArray(values) && values.find(cv => cv.Id === currentControlId)) ?? false;
            } else {
                isChecked = (values ?? "").toString() === currentControlId;
            }
        }
        //console.log(`${props.fieldInfo.Name}: isChecked=${isChecked}`);
        return isChecked;
    }
    return <>
        {
            meta.map(rb => {
                const controlId = `${props.fieldInfo.Name}_${rb.Id}`;
                return <div id={`region_${controlId}`} key={`region_${controlId}`}>
                    <input type="checkbox"
                           data-toggle="toggle"
                           checked={getChecked(rb.Id)}
                           readOnly={props.readOnly}
                           disabled={props.readOnly}
                           onChange={(e) => onChange(rb.Id, e)}
                           id={controlId}
                           key={controlId}
                           style={{cursor:"pointer"}}
                    />&nbsp;
                    <label htmlFor={controlId} className="form-check-label">
                        {rb.Title}
                    </label>
                </div>
            })
        }
    </>;
}

CheckBoxJson.propTypes = {
    dataItem: PropTypes.object.isRequired,
    fieldInfo: PropTypes.object.isRequired,
    rowIndex: PropTypes.number.isRequired,
    readOnly: PropTypes.bool,
    value: PropTypes.any,
    onChanged: PropTypes.func
};

export default CheckBoxJson;